export default __webpack_public_path__ + "static/media/com_fm.be535290.png";